import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    setTimeout(() => {
      if (email && password) {
        localStorage.setItem('vip_admin_auth', 'true');
        navigate('/');
      } else {
        setError('Lütfen e-posta ve şifre giriniz.');
        setLoading(false);
      }
    }, 800);
  };

  return (
    <div className="min-h-screen bg-vip-black flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 rounded-xl overflow-hidden mx-auto mb-4 border-2 border-vip-gold/30">
            <img
              src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/a7876054204e657e23ebb298605caa33.jpeg"
              alt="VIP Antalya Transfer"
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-2xl font-display font-bold text-vip-gold">
            VIP Antalya Transfer
          </h1>
          <p className="text-sm text-gray-400 mt-1">Yönetim Paneli</p>
        </div>

        {/* Login Card */}
        <div className="bg-vip-dark border border-vip-gold/15 rounded-xl p-6 md:p-8">
          <h2 className="text-lg font-semibold text-white mb-1">Giriş Yap</h2>
          <p className="text-sm text-gray-400 mb-6">Hesabınıza giriş yapın</p>

          {error && (
            <div className="mb-4 p-3 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm text-gray-300 mb-1.5">E-posta</label>
                <div className="relative">
                  <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-gray-500 text-sm"></i>
                  </div>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full bg-vip-surface border border-vip-gold/10 rounded-lg pl-10 pr-4 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-vip-gold/30 focus:ring-1 focus:ring-vip-gold/20 transition-colors"
                    placeholder="admin@vipantalya.com"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-300 mb-1.5">Şifre</label>
                <div className="relative">
                  <div className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center">
                    <i className="ri-lock-line text-gray-500 text-sm"></i>
                  </div>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full bg-vip-surface border border-vip-gold/10 rounded-lg pl-10 pr-4 py-2.5 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-vip-gold/30 focus:ring-1 focus:ring-vip-gold/20 transition-colors"
                    placeholder="********"
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-vip-gold hover:bg-vip-gold-light text-vip-black font-semibold py-2.5 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm whitespace-nowrap"
              >
                {loading ? (
                  <span className="flex items-center justify-center gap-2">
                    <i className="ri-loader-4-line animate-spin"></i>
                    Giriş yapılıyor...
                  </span>
                ) : (
                  'Giriş Yap'
                )}
              </button>
            </div>
          </form>

          <div className="mt-4 text-center">
            <p className="text-xs text-gray-500">
              Demo giriş için herhangi bir e-posta ve şifre giriniz.
            </p>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-gray-600 mt-6">
          &copy; 2026 VIP Antalya Transfer. Tüm hakları saklıdır.
        </p>
      </div>
    </div>
  );
}